import { useCms } from "./useCms";
import { Field, Panel, ListControls, AddButton, moveItem } from "./Fields";

const MODULES = ["finance", "expenses", "invoices", "reports", "employees", "attendance", "payroll", "approvals", "organization", "multi_center", "partner_settlement", "candidates"];

export default function PlansEditor() {
  const { data, setData, save, saving } = useCms("plans", []);
  const list = Array.isArray(data) ? data : [];
  const update = (i, patch) => setData(list.map((p, idx) => (idx === i ? { ...p, ...patch } : p)));
  const num = (v) => (v === "" ? null : Number(v));

  return (
    <Panel title="Pricing Plans" description="Prices are in ₹. Limits are enforced by the platform; leave a limit empty for unlimited. Changing plan IDs affects existing subscriptions — avoid." onSave={() => save(list)} saving={saving} saveTestid="plans-save">
      <div className="space-y-5">
        {list.map((p, i) => (
          <div key={p.id || i} data-testid={`plan-row-${p.id || i}`} className="rounded-xl border border-slate-200 p-4">
            <div className="flex items-center justify-between mb-3">
              <div className="flex items-center gap-4">
                <span className="text-xs font-mono text-slate-500">id: {p.id}</span>
                <label className="flex items-center gap-2 text-sm font-medium text-slate-700">
                  <input type="checkbox" data-testid={`plan-popular-${p.id}`} checked={!!p.popular} onChange={(e) => update(i, { popular: e.target.checked })} /> Most Popular badge
                </label>
              </div>
              <ListControls index={i} total={list.length} onMove={(a, b) => setData(moveItem(list, a, b))} onRemove={(idx) => setData(list.filter((_, j) => j !== idx))} testid={`plan-delete-${p.id}`} />
            </div>
            <div className="grid md:grid-cols-4 gap-3">
              <Field label="Plan name" value={p.name} onChange={(v) => update(i, { name: v })} testid={`plan-name-${p.id}`} />
              <Field label="Tagline" value={p.tagline} onChange={(v) => update(i, { tagline: v })} />
              <Field label="Monthly price (₹)" type="number" value={p.monthly_price} onChange={(v) => update(i, { monthly_price: Number(v) })} testid={`plan-monthly-${p.id}`} />
              <Field label="Annual price (₹)" type="number" value={p.annual_price} onChange={(v) => update(i, { annual_price: Number(v) })} testid={`plan-annual-${p.id}`} />
              <Field label="Users label" value={p.users} onChange={(v) => update(i, { users: v })} />
              <Field label="Centers label" value={p.centers} onChange={(v) => update(i, { centers: v })} />
              <Field label="Support label" value={p.support} onChange={(v) => update(i, { support: v })} />
              <div className="grid grid-cols-2 gap-2">
                <Field label="User limit" type="number" value={p.user_limit ?? ""} onChange={(v) => update(i, { user_limit: num(v) })} />
                <Field label="Center limit" type="number" value={p.center_limit ?? ""} onChange={(v) => update(i, { center_limit: num(v) })} />
              </div>
            </div>
            <div className="mt-3">
              <Field label="Features (one per line)" multiline value={(p.features || []).join("\n")} onChange={(v) => update(i, { features: v.split("\n").filter((s) => s.trim()) })} testid={`plan-features-${p.id}`} />
            </div>
            <div className="mt-3">
              <p className="text-xs text-slate-600 mb-2">Modules included</p>
              <div className="flex flex-wrap gap-2">
                {MODULES.map((m) => {
                  const on = (p.modules || []).includes(m);
                  return (
                    <button key={m} type="button" onClick={() => update(i, { modules: on ? p.modules.filter((x) => x !== m) : [...(p.modules || []), m] })}
                      className={`text-xs px-2.5 py-1 rounded-full border ${on ? "bg-emerald-700 text-white border-emerald-700" : "border-slate-300 text-slate-600"}`}>{m}</button>
                  );
                })}
              </div>
            </div>
          </div>
        ))}
      </div>
      <AddButton label="Add plan" testid="plan-add" onClick={() => setData([...list, { id: `plan_${Date.now().toString(36)}`, name: "", tagline: "", monthly_price: 0, annual_price: 0, popular: false, users: "", centers: "", support: "", user_limit: null, center_limit: null, modules: [], features: [] }])} />
    </Panel>
  );
}
